import { useMutation } from '@tanstack/react-query';

import useOnAsyncError from '@/hooks/useOnAsyncError';
import { getCategoryEntries } from '@/lib/api/category';

const useGetCategoryEntries = () => {
  const handleAsyncError = useOnAsyncError();

  return useMutation({
    mutationFn: ({
      categoryId,
      fromDate,
      toDate,
    }: {
      categoryId: number;
      fromDate: Date;
      toDate: Date;
    }) => {
      const from = fromDate.toISOString();
      const to = toDate.toISOString();

      return getCategoryEntries(categoryId, from, to);
    },
    onError: handleAsyncError,
  });
};

export default useGetCategoryEntries;
